import{createContext as t}from"react";const o=t(0);export{o as default};
